import React, { useEffect, useState } from "react";
import { Grid, Typography, CircularProgress } from "@mui/material";
import "../../assets/css/UploadDocument.css";

const UploadDocument = ({
  title,
  uploadFiles,
  removeFilePractice,
  errors,
  documentPractice,
  errorFileLarge,
}) => {
  const [files, setFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [errorFileLimiteMultiple, setErrorFileLimiteMultiple] = useState(null);
  const [errorExtensionAccept, setErrorExtensionAccept] = useState(null);
  const [removeFileBool, setRemoveFileBool] = useState(null);

  useEffect(() => {
    if ((documentPractice && !removeFileBool) || errorFileLarge) {
      setFiles(documentPractice);
    }
  }, [documentPractice, errorFileLarge]);

  const handleDrop = async (event) => {
    setErrorFileLimiteMultiple(null);
    event.preventDefault();

    const droppedFiles = Array.from(event.dataTransfer.files);

    const allowedExtensions = [
      ".pdf",
      ".jpg",
      ".jpeg",
      ".docx",
      ".png",
      ".msg",
      ".eml",
      ".txt",
      ".odt",
      ".dot",
      ".xml",
    ];

    const validFiles = droppedFiles.filter((file) => {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (!allowedExtensions.includes(`.${fileExtension}`)) {
        setErrorExtensionAccept(true);
        return false;
      }

      if (file.size > 30 * 1024 * 1024) {
        setErrorFileLimiteMultiple(true);
        return false;
      }

      return true;
    });

    if (validFiles.length > 0) {
      setIsUploading(true);
      await uploadFiles(validFiles);
      setFiles((prevFiles) => [...prevFiles, ...validFiles]);
      setIsUploading(false);
    }
  };

  const handleFileChange = async (event) => {
    setErrorFileLimiteMultiple(null);
    const selectedFiles = Array.from(event.target.files);
    const allowedExtensions = [
      ".pdf",
      ".jpg",
      ".jpeg",
      ".docx",
      ".png",
      ".msg",
      ".eml",
      ".txt",
      ".odt",
      ".dot",
      ".xml",
    ];

    const validFiles = selectedFiles.filter((file) => {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (!allowedExtensions.includes(`.${fileExtension}`)) {
        setErrorExtensionAccept(true);
        return false;
      }

      if (file.size > 30 * 1024 * 1024) {
        setErrorFileLimiteMultiple(true);
        return false;
      }
      return true;
    });

    if (validFiles.length > 0) {
      setIsUploading(true);
      await uploadFiles(validFiles);
      setFiles((prevFiles) => [...prevFiles, ...validFiles]);
      setIsUploading(false);
    }
  };

  const removeFile = (index) => {
    setErrorFileLimiteMultiple(null);
    const fileToRemove = files[index];

    const updatedFiles = files.filter((_, i) => i !== index);

    setFiles(updatedFiles);
    setRemoveFileBool(true);

    removeFilePractice(fileToRemove, updatedFiles);
  };

  return (
    <>
      <Typography
        className="color-blue-dark title-input"
        style={{ marginBottom: "8px" }}
      >
        {title}
      </Typography>
      <Grid
        id="file-upload-area"
        item
        xs={12}
        style={{
          backgroundColor: "#d3d3d382",
          height: "250px",
          maxHeight: "500px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          // padding: "20px",
          cursor: "pointer",
          border:
            errors?.includes("documentAssignment") ||
            errorFileLarge ||
            errorFileLimiteMultiple ||
            errorExtensionAccept
              ? "1px solid #bc2957"
              : "none",
        }}
        onDrop={handleDrop}
        onDragOver={(event) => event.preventDefault()}
        onClick={(event) => {
          if (event.target && event.target.tagName !== "A") {
            document.getElementById("file-input")?.click();
          }
        }}
      >
        <div className="icon-upload-document" />
        <Typography
          sx={{ fontSize: { xs: "12px", sm: "16px" } }}
          className="color-blue-dark"
        >
          Seleziona o trascina qui i file da allegare
        </Typography>
        <Typography
          sx={{ fontSize: { xs: "12px", sm: "16px" } }}
          className="color-blue-dark"
        >
          Estensioni accettate: pdf, jpg, png, docx, msg, eml, txt, odt, dot,
          xml
        </Typography>
        <Typography
          sx={{ fontSize: { xs: "12px", sm: "16px" } }}
          className="color-blue-dark"
        >
          Dimensione complessiva massima dei file: 30 MB
        </Typography>

        <input
          type="file"
          // accept=".pdf,.jpg,.docx"
          multiple
          onChange={handleFileChange}
          style={{ display: "none" }}
          id="file-input"
        />

        {isUploading && (
          <CircularProgress
            style={{
              marginTop: "20px",
              color: "#1b2838",
              width: "20px",
              height: "20px",
            }}
          />
        )}

        {files.length > 0 && (
          <div
            style={{
              marginTop: "20px",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              overflowY: "auto",
              maxHeight: "300px",
            }}
          >
            {files.map((file, index) => (
              <Grid
                container
                alignItems="center"
                key={index}
                style={{
                  marginBottom: "5px",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="body2"
                  color="textSecondary"
                  style={{
                    wordBreak: "break-word",
                    color: "#1b2838",
                    textAlign: "center",
                  }}
                  className="truncate-file-name"
                >
                  {file.original_name_attached || file.name}
                </Typography>
                <div
                  className="icon-remove-file"
                  style={{
                    marginLeft: "10px",
                    cursor: "pointer",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    removeFile(index);
                  }}
                ></div>
              </Grid>
            ))}
          </div>
        )}

        {(errorFileLarge || errorFileLimiteMultiple) && (
          <>
            <Typography className="color-purple">
              L'ultimo file che stai provando a caricare supera la dimensione
              massima consentita.
            </Typography>
            <Typography className="color-purple">
              Puoi ridurre la dimensione dei file utilizzando questo{" "}
              <a
                target="_blank"
                className="color-purple"
                href="https://tools.pdf24.org/it/comprimi-pdf"
                onClick={(e) => e.stopPropagation()}
              >
                tool online
              </a>
              .
            </Typography>
          </>
        )}
      </Grid>
    </>
  );
};

export default UploadDocument;
